<template>
  <div class="upload-video" @click.stop="uploadVideo">
    <template v-if="!Boolean($slots.default)">
      <div class="upload-icon">
        <i class="iconfont icon-tianjia"></i>
      </div>
      <div class="upload-desc">上传</div>
    </template>
    <template v-else>
      <slot></slot>
    </template>
    <input
      ref="uploadVideo"
      style="display: none;"
      type="file"
      accept="video/*"
      @change="uploadFile"
      @click.stop="() => {}"
    />
    <el-dialog title="编辑视频" append-to-body width="400px" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="封面">
          <el-input v-model="form.cover"></el-input>
        </el-form-item>
        <el-form-item label="视频">
          <el-input v-model="form.src"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleUpload">手动上传</el-button>
        <el-button type="primary" @click="handleEdit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// upload
import { uploadFile } from "@/plugins/uploadFile";
import { uploadFileMulti } from "@/plugins/uploadFileMulti";
// element-ui
import { Message } from "element-ui";
import ProgressBar from "../ProgressBar";

export default {
  name: "UploadImage",
  components: {
    ProgressBar
  },
  props: {
    type: {
      type: String,
      default: "add"
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      uploadProgressList: [],
      dialogVisible: false,
      form: {
        cover: "",
        src: ""
      }
    };
  },

  mounted() {},

  methods: {
    uploadVideo() {
      if (this.type == "edit") {
        this.dialogVisible = true;
        this.form = JSON.parse(JSON.stringify(this.data));
        return;
      }
      this.$refs.uploadVideo.click();
    },
    handleUpload() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$refs.uploadVideo.click();
      });
    },
    handleEdit() {
      this.dialogVisible = false;
      this.$emit("onUploaded", this.from.cover, this, form.src);
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        cover: "",
        src: ""
      };
    },
    // 获取本地视频第一针图片
    getVideoPoster(file) {
      return new Promise((resolve, reject) => {
        let url = window.URL.createObjectURL(file);
        let videoDom = document.createElement("video");
        videoDom.setAttribute("crossOrigin", "Anonymous");
        videoDom.autoplay = true;
        // videoDom.currentTime = 1;
        videoDom.muted = true;
        videoDom.onloadeddata = () => {
          let h = videoDom.videoHeight;
          let w = videoDom.videoWidth;

          if (w > 500) {
            h = (500 / w) * h;
            w = 500;
          }
          let canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(videoDom, 0, 0, w, h);
          let _url = canvas.toDataURL("image/png");
          _url = this.dataURLtoFile(_url, "img.png");
          resolve(_url);
        };
        videoDom.src = url;
      });
    },
    // base64转file;
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    },
    renderProgress() {
      const h = this.$createElement;
      const progressVdomList = this.uploadProgressList.map((item, index) => {
        return h("ProgressBar", {
          ref: "progress_" + index,
          key: index,
          props: {
            name: item.file.name,
            percentage: parseInt(item.percent) || 0
          }
        });
      });

      this.$notify({
        title: "上传中",
        message: h("div", { style: { width: "280px" } }, progressVdomList),
        duration: 0
      });
    },
    async uploadFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      try {
        this.uploadProgressList = [
          {
            file,
            percent: 0
          }
        ];
        // 上传进度
        this.renderProgress();

        const video = await this.uploadVideoFile(file, 0);
        // 关闭上传进度
        setTimeout(() => {
          this.$notify.closeAll();
        }, 3000);

        if (video && video !== "error") {
          this.$emit("onUploaded", video.cover, video.url);
        }
      } catch (error) {
        console.log(error);
      } finally {
        // 重置上传器
        this.$refs.uploadVideo.value = "";
      }
    },
    async uploadVideoFile(file, index) {
      try {
        const coverFile = await this.getVideoPoster(file);
        // 上传封面
        const res = await Promise.all([
          uploadFile({
            file: coverFile,
            is_video: true
          }),
          uploadFileMulti({
            file: file,
            waterMark: 0,
            is_video: true,
            progressCb: percent => {
              setTimeout(() => {
                this.$refs["progress_" + index].setPercentage(parseInt(percent));
                if (percent == 100) {
                  this.$refs["progress_" + index].setStatus("success");
                }
              }, 500);
            }
          })
        ]);

        // console.log(1, res);
        const cover = res[0].url;
        const url = res[1].url;
        // console.log(2, url);
        // this.$emit("onUploaded", cover, url);
        return { cover, url };
      } catch (error) {
        Message({
          message: "视频上传错误！",
          type: "error"
        });
        this.$refs["progress_" + index].setStatus("exception");
        console.log(error);
        return "error";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.upload-video {
  width: 100%;
  height: 100%;
  background: #727c86;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  vertical-align: top;
  .upload-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
    color: #fff;
  }
  .upload-desc {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
</style>
